<template>
  <div class="bgf5">

    <!--
		* 页脚蓝色横幅
		* xuzhongqi
		* 2020.12.09
 -->
    <footer>
      <div class="footer-box">
        <div class="footer-box-flex">
          <div v-for="(item,index) in list" :key="index" class="footer-item">
            <van-icon class="footer-icon" :name="require(`../assets/footer/${item.icon}.png`)" size="58px" />
            <span class="">{{ item.name }}</span>
          </div>
        </div>
      </div>
    </footer>
    <!-- 页脚蓝色横幅 end -->

    <div v-if="!simple" class="foot-list">
      <van-row type="flex">
        <van-col :span="3" class="text-left">
          <div class="f16 c222">新手指南</div>
          <ul>
            <li>
              <router-link
                :to="{name:LinkTypeCode.HelpCenter,query:{activedParentKey:1,activedKey:11,Id:'151b6f48-6183-4a99-d213-08d80ea802d0'}}"
                class="c777 ihover"
              >用户注册</router-link>
            </li>
            <li>
              <router-link
                :to="{name:LinkTypeCode.HelpCenter,query:{activedParentKey:1,activedKey:12,Id:'77f5fd3b-4404-4d91-5072-08d811cf9ba3'}}"
                class="c777 ihover"
              >用户登录</router-link>
            </li>
            <li>
              <router-link
                :to="{name:LinkTypeCode.HelpCenter,query:{activedParentKey:1,activedKey:13,Id:'04303a48-f607-4c9e-5073-08d811cf9ba3'}}"
                class="c777 ihover"
              >采购指南</router-link>
            </li>
            <li>
              <router-link
                :to="{name:LinkTypeCode.HelpCenter,query:{activedParentKey:1,activedKey:14,Id:'4e90294b-d543-4f89-5074-08d811cf9ba3'}}"
                class="c777 ihover"
              >首营认证</router-link>
            </li>
          </ul>
        </van-col>
        <van-col :span="3" class="text-left">
          <div class="f16 c222">常见问题</div>
          <ul>
            <li>
              <router-link
                :to="{name:LinkTypeCode.HelpCenter,query:{activedParentKey:3,activedKey:31,Id:'be462f34-116d-44f1-5078-08d811cf9ba3'}}"
                class="c777 ihover"
              >优惠券使用</router-link>
            </li>
            <li>
              <router-link
                :to="{name:LinkTypeCode.HelpCenter,query:{activedParentKey:3,activedKey:32,Id:'164e7169-71a6-45e6-5079-08d811cf9ba3'}}"
                class="c777 ihover"
              >限额说明</router-link>
            </li>
            <li>
              <router-link
                :to="{name:LinkTypeCode.HelpCenter,query:{activedParentKey:3,activedKey:33,Id:'3974cfed-e52e-4896-507a-08d811cf9ba3'}}"
                class="c777 ihover"
              >支付方式</router-link>
            </li>
            <li>
              <router-link
                :to="{name:LinkTypeCode.HelpCenter,query:{activedParentKey:3,activedKey:34,Id:'0c63a723-d130-48fc-507b-08d811cf9ba3'}}"
                class="c777 ihover"
              >门店切换</router-link>
            </li>
          </ul>
        </van-col>
        <van-col :span="3" class="text-left">
          <div class="f16 c222">售后服务</div>
          <ul>
            <li>
              <router-link
                :to="{name:LinkTypeCode.HelpCenter,query:{activedParentKey:2,activedKey:21,Id:'44d3d2f7-3e87-4033-5075-08d811cf9ba3'}}"
                class="c777 ihover"
              >退款流程</router-link>
            </li>
            <li>
              <router-link
                :to="{name:LinkTypeCode.HelpCenter,query:{activedParentKey:2,activedKey:22,Id:'611c80e6-c09f-4dde-5076-08d811cf9ba3'}}"
                class="c777 ihover"
              >退货流程</router-link>
            </li>
            <li>
              <router-link
                :to="{name:LinkTypeCode.HelpCenter,query:{activedParentKey:2,activedKey:23,Id:'d2ddba79-7b5f-4360-5077-08d811cf9ba3'}}"
                class="c777 ihover"
              >订单开票</router-link>
            </li>
          </ul>
        </van-col>
        <van-col :span="3" class="text-left">
          <div class="f16 c222">关于我们</div>
          <ul>
            <li>
              <router-link
                :to="{name:LinkTypeCode.HelpCenter,query:{activedParentKey:4,activedKey:41,Id:'3e440c62-8c0b-49dc-507c-08d811cf9ba3'}}"
                class="c777 ihover"
              >平台介绍</router-link>
            </li>
            <li>
              <router-link
                :to="{name:LinkTypeCode.HelpCenter,query:{activedParentKey:4,activedKey:42,Id:'56d17744-f8c3-4793-507d-08d811cf9ba3'}}"
                class="c777 ihover"
              >用户协议</router-link>
            </li>
          </ul>
        </van-col>
        <van-col v-if="false" :span="6" class="text-left">
          <div class="f16 c222">服务热线</div>
          <ul>
            <li>
              <span class="fAkrobat c0F6EE9 fw900 f24">{{ lang.Basic.ServicePhone }}</span>
            </li>
            <li>周一至周日 8:00-18:00</li>
          </ul>
        </van-col>
        <van-col :span="6" class="flex justify-content-flex-end">
          <ul style="margin-top: 0; margin-right: 40px;">
            <li style="margin-top: 0;">
              <van-image :src="require('../assets/download/qrcode.png')" width="118px" height="118px" />
            </li>
            <li>下载药约約手机app</li>
          </ul>
        </van-col>
      </van-row>
    </div>
    <div class="foot-tip" :style="{marginTop:simple?'0px':'30px',paddingTop:simple?'30px':'0px'}">
      营业执照统一社会信用代码：91510000762328328E | 药品经营许可证：川AA0280340 | 药品经营质量管理规范认证：SC01-Aa-20190340 <br> 互联网药品信息服务资格证书：(川)-非经营性-2020-0055 |
      互联网药品交易服务资格证书：川B20160001
      <!-- <br>CopyRight @ 药约約 2020 - 2025 -->
      <br>备案号： <a href="https://beian.miit.gov.cn/" target="_blank">蜀ICP备15015193号-2</a>
    </div>
  </div>
</template>
<script>
import { LinkTypeCode } from '../dictionary/base'
export default {
  name: 'Footer',
  props: {
    simple: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      LinkTypeCode,
      list: [
        {
          name: '没有中间商赚差价',
          icon: 'footer-icon-1'
        },
        {
          name: '控销做的更好',
          icon: 'footer-icon-2'
        },
        {
          name: '百强品质、质量保证',
          icon: 'footer-icon-3'
        },
        {
          name: '好医生出品、值得信赖',
          icon: 'footer-icon-4'
        }]
    }
  }
}
</script>
<style lang="less" scoped>
  .footer-box {
    font-size: 20px;
    color: #FFFFFF;
    background: url("../assets/foot-bg.png") no-repeat;
    background-size: 100% 163px;

    .footer-box-flex {
      display: flex;
      margin: 0 auto;
      width: 1200px;
      box-sizing: border-box;

      .footer-item {
        height: 163px;
        flex: 0 0 25%;
        line-height: 163px;

        .footer-icon {
          vertical-align: middle;

          img {
            margin-right: 24px;
            width: 58px;
            vertical-align: initial;
          }
        }
      }
    }
  }

  .foot-list {
    margin: 0 auto;
    margin-top: 40px;
    border-bottom: 1px solid #DDDDDD;
    padding-bottom: 40px;
    padding-left: 50px;
    width: 1200px;
    box-sizing: border-box;

    ul {
      margin-top: 20px;

      li {
        margin-top: 10px;
        font-size: 14px;
        text-align: left;
        color: #777777;
      }
    }

    /deep/.van-col:not(:last-child) {
      position: relative;

      &::after {
        position: absolute;
        top: 50%;
        right: 40px;
        width: 1px;
        height: 130px;
        background:
          linear-gradient(
            to bottom,
            rgba(216, 216, 216, .1) 0%,
            rgba(216, 216, 216, .5) 30%,
            rgba(216, 216, 216, 1) 50%,
            rgba(216, 216, 216, .5) 70%,
            rgba(216, 216, 216, .1) 100%
          );
        content: "";
        transform: translateY(-50%);
      }
    }
  }

  .foot-tip {
    margin: 30px auto 0;
    padding-bottom: 60px;
    font-size: 12px;
    color: #777777;
    line-height: 17px;
  }
</style>
